import axiosInstance from "config/axios";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../store";

interface SessionDescProps {
  sessionName: string;
  programmeName: string;
  batchName: string;
  date: string;
  overallDuration: string;
  sessionDuration: string;
  totalParticipants: number;
  onlineParticipants: number;
  sessionId: String;
  roomID: string;
  programId: string;
}

const SessionDescription = ({
  sessionName,
  programmeName,
  batchName,
  date,
  overallDuration,
  sessionDuration,
  totalParticipants,
  onlineParticipants,
  roomID,
  programId
}: // onJoin,
  SessionDescProps) => {
  const router = useNavigate();
  const user = useSelector((state: RootState) => state.auth.user)
  const sessionId = useSelector((state: RootState) => state.live.settings.roomId)
  const handleJoin = async () => {
    router(`/live-session?sessionId=${roomID}&programId=${programId}`);
  };



  return (
    <div className="bg-zinc-900 h-full flex flex-col justify-between text-white rounded-2xl  space-y-4">
      <div className="grid grid-cols-2 mobile:p-2 p-6 gap-6">
        <div className="space-y-4 text-sm mobile:text-left">
          <div>
            <p className="opacity-75 ">Session</p>
            <p className="font-bold">{sessionName}</p>
          </div>
          <div>
            <p className="opacity-75">Programme</p>
            <p className="font-bold">{programmeName}</p>
          </div>
          <div>
            <p className="opacity-75 ">Batch</p>
            <p className="font-bold">{batchName}</p>
          </div>
        </div>
        <div className="space-y-4 text-sm mobile:text-right">
          <div>
            <p className="opacity-75 ">Date</p>
            <p className="font-bold">{date}</p>
          </div>
          <div>
            <p className="opacity-75 ">Overall Duration</p>
            <p className="font-bold">{overallDuration}</p>
          </div>
          <div>
            <p className="opacity-75 ">Session Duration</p>
            <p className="font-bold">{sessionDuration}</p>
          </div>
        </div>
      </div>
      <div className="flex flex-col items-center justify-center space-y-2 ">
        <button
          onClick={() => handleJoin()}
          className="flex justify-center align-middle w-56 h-12 bg-app-blue rounded-md text-xl font-bold contrast-100 disabled:bg-slate-600 disabled:cursor-not-allowed"
        >
          <span className="flex my-auto">Join</span>
        </button>
        <span className="text-green-800">
          {onlineParticipants}/ {totalParticipants} Participants Online
        </span>
      </div>
    </div>
  );
};

export default SessionDescription;
